import { Sheet, SheetClose, SheetContent, SheetTitle } from '@/components/ui/sheet'
import { EventFilterFacets } from './EventFilterSidebar'
import { DEFAULT_FILTERS } from '../../../utils/eventFilters'

// Mobile bottom sheet wrapping the same facet sections as the desktop
// sidebar. Filters apply immediately (URL params); the footer button just
// dismisses with a live result count.
const EventFilterSheet = ({
  open,
  onOpenChange,
  filters,
  onChange,
  locationCounts,
  typeCounts,
  resultCount,
}) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent
      side="bottom"
      hideClose
      aria-describedby={undefined}
      overlayClassName="bg-black/45 backdrop-blur-[2px]"
      className="inset-x-0 bottom-0 top-[110px] flex flex-col gap-0 rounded-t-[20px] border-t-0 bg-white p-0 shadow-2xl data-[state=closed]:duration-300 data-[state=open]:duration-300"
    >
      <div className="mx-auto mt-2.5 h-1 w-10 shrink-0 rounded-full bg-gray-300" aria-hidden="true" />

      <div className="flex shrink-0 items-center justify-between border-b border-gray-100 px-5 py-3">
        <SheetTitle className="font-serif text-[19px] font-medium text-primary-800">
          Filters
        </SheetTitle>
        <button
          type="button"
          className="text-[13px] font-semibold text-primary-600 hover:text-primary-700"
          onClick={() => onChange({ ...DEFAULT_FILTERS, date: { kind: 'all' }, types: [] })}
        >
          Clear all
        </button>
      </div>

      <div className="flex flex-1 flex-col gap-5 overflow-y-auto px-5 pb-5 pt-4">
        <EventFilterFacets
          filters={filters}
          onChange={onChange}
          locationCounts={locationCounts}
          typeCounts={typeCounts}
        />
      </div>

      <div className="shrink-0 border-t border-gray-100 bg-white px-5 pb-8 pt-3.5">
        <SheetClose asChild>
          <button
            type="button"
            className="w-full rounded-[10px] bg-primary-600 py-3.5 text-[15px] font-semibold text-white transition hover:bg-primary-700"
          >
            Show {resultCount} {resultCount === 1 ? 'experience' : 'experiences'}
          </button>
        </SheetClose>
      </div>
    </SheetContent>
  </Sheet>
)

export default EventFilterSheet
